const printTicketsScreenRegex = /^\/print-tickets\/[^\/]+$/;

const checkPrintTickets = () => {
  const location = window.location;
  const query = new URLSearchParams(location.search);
  const pathname = location.pathname;
  const fromEmail = query.get('fromEmail');
  const accessPrintTicketFromEmailLink =
    printTicketsScreenRegex.test(pathname) && fromEmail === '1';

  return {
    accessPrintTicketFromEmailLink,
  };
};

export default checkPrintTickets;
